/**
 * Created by shani on 02/01/18.
 */
import { AbstractDTO } from "./abstract";
import { IInlineEditorError } from "@signature-it/ngx-generic/interfaces";

export class InlineEditorErrorDTO extends AbstractDTO implements IInlineEditorError{
    type: string;
    message: string;
    // input: InputBase;

    constructor(attributes: Object) {
        super(attributes);
        this.type = attributes['type'] || '';
        this.message = attributes['message'] || '';
        // this.input = attributes['input'] || '';
    }
}
